import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

export const NotAuthorized = () => {
    return (
        <div className="txt-center">
            <h1>NOT AUTHORIZED</h1>
            <p>It appears you don't have access to this page.</p>
        </div>
    );
};

const PrivateRoute = ({ component: Component, allowedGroups = [], ...rest }) => {
    const { state: authState } = useContext(AuthContext);

    return (
        <Route
            {...rest}
            render={(props) => {
                if (!authState.user) {
                    return (
                        <Redirect
                            to={{
                                pathname: '/sign-in',
                                state: { from: props.location }
                            }}
                        />
                    );
                }

                return <Component {...props} />;
            }}
        />
    );
};

export default PrivateRoute;
